import { render } from "./FatButton.vue?vue&type=template&id=cf8f4d70&scoped=true"
import script from "./FatButton.vue?vue&type=script&lang=js"
export * from "./FatButton.vue?vue&type=script&lang=js"

import "./FatButton.vue?vue&type=style&index=0&id=cf8f4d70&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf8f4d70"]])

export default __exports__